import { DebtorComponent } from "projects/reg-hub-client/src/app/orders/debtor/debtor.component";
import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { LandTitleSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/land-title-search-criteria/land-title-search-criteria.component";
import { LandTitleSearchCriteriaReviewComponent } from "projects/reg-hub-client/src/app/orders/land-title-search-criteria-review/land-title-search-criteria-review.component";

export class ONLandTitleSearchStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Search Criteria", content: LandTitleSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Debtor Name", content: DebtorComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: LandTitleSearchCriteriaReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}